import appHeader from "@shared/app-header"
import appSidebar from "@/components/app-sidebar"
import alert from "@/components/alert-box"
import pagination from "@/components/pagination"
// import axios from "@/axios"
import { mapActions, mapGetters } from "vuex";
import { checkPermission } from "@shared/utils/functions"

export default {
  name: 'dashboard',
  components: {
    appHeader,
    appSidebar,
    alert,
    pagination,
  },
  props: [],
  data () {
    return {
      isLoading: true,
    }
  },
  title: "Dashboard",
  computed: {
    ...mapGetters(["getNotificationCount", "getThemeUseDefault", "getThemeColors", "getTenantId", "getDefaultColors"]),
    themeColors() {
      const colors = this.getThemeUseDefault === false ? this.getThemeColors : this.getDefaultColors;
      return Object.values(colors).reduce((result, color) => {
        if (color.value) result[color.var] = color.value;
        return result;
      }, {})
    },
  },
  async created () {
    this.isLoading = true;
    await this.fetchTenant(this.getTenantId);
    await this.fetchNewTenantId();
    await this.fetchTenant(this.getTenantId);
    this.isLoading = false;
  },
  methods: {
    checkPermission,
    ...mapActions(["fetchNotificationCount", "fetchTenant"]),

    async fetchNewTenantId() {
      if (!this.$store.getters.getTenantId) {
        await this.$store.dispatch("fetchTenantId");
        // this.tenant_id = this.$store.getters.getTenantId;
      }
      await this.fetchNotificationCount()
      // try {
      //   const { data } = await axios.post(`user-auth/init`)
      //   if(data){
      //     console.log('data.tenant_id :>> ', data.tenant_id);
      //     this.$store.dispatch("setTenantId", data.tenant_id)
          // if (data.effective_role === 'tenant_super_admin') this.$router.push({path: '/field-table'})
      //   }
        
      // } catch (error) {
      //   console.log(error.message || `Error fetching tenant ID `);        
      // }
    },
    // async fetchDashboardNotification(){
    //   try{
    //     const { data } = await axios.get(`dashboard-notifications/tenant/count`)
    //     this.notificationCount = data.data
    //   }
    //   catch(error){
    //     console.log(">>>> error", error)
    //   }
    // }

  }
}


